enum TrafficSourceTypeMetric {
    SearchVisits = "search_visits",
    PaidSearchVisits = "paid_search_visits",
    OrganicSearchVisits = "organic_search_visits",
    DirectVisits = "direct_visits",
    SocialVisits = "social_visits",
    OrganicSocialVisits = "organic_social_visits",
    PaidSocialVisits = "paid_social_visits",
    ReferralsVisits = "referrals_visits",
    DisplayAdsVisits = "displayads_visits",
    MailVisits = "mail_visits",
    GenAiVisits = "gen_ai_visits",
    AffiliateVisits = "affiliate_visits",
}

export default TrafficSourceTypeMetric;
